
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL as string | undefined;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY as string | undefined;

const isValid = !!SUPABASE_URL && !!SUPABASE_ANON_KEY && SUPABASE_URL.startsWith('http') && SUPABASE_ANON_KEY.length > 20;

// In a production SaaS, we do not allow hardcoded fallbacks.
// If env vars are missing, the app should show a configuration error screen.
export const supabase = createClient(SUPABASE_URL || '', SUPABASE_ANON_KEY || '');

export const isSupabaseConfigured = () => isValid;

